import React from 'react';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * @remarks Page header for dialogs.
 * @param param0 - values for setting the header of the page.
 * @returns - an Html component of the page header.
 */
export const PageHeader = ({ title, onBackClick, showBackButton = false }) => {
    return (
        <Toolbar className="page-header">
            <Typography align='center' variant="h6" style={{ flexGrow: 1 }} >{title}</Typography>
            {
                showBackButton && onBackClick && (
                    <Button onClick={onBackClick} startIcon={<ArrowBackIcon />}>
                        Back
                    </Button>
                )
            }
        </Toolbar >
    );
}
